import { render, staticRenderFns } from "./ReservationWarningModal.vue?vue&type=template&id=af7208ee&lang=pug&"
import script from "./ReservationWarningModal.vue?vue&type=script&lang=js&"
export * from "./ReservationWarningModal.vue?vue&type=script&lang=js&"
import style0 from "./ReservationWarningModal.vue?vue&type=style&index=0&id=af7208ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports